export const UPDATE_PLAYLIST_SELECTION = "UPDATE_PLAYLIST_SELECTION";
export const CREATE_INITIAL_PLAYLIST = "CREATE_INITIAL_PLAYLIST";
export const CREATE_FINAL_PLAYLIST = "CREATE_FINAL_PLAYLIST";
export const UPDATE_FINAL_PLAYLIST = "UPDATE_FINAL_PLAYLIST";
export const CREATE_FAILED_TO_FIND_PLAYLIST = "CREATE_FAILED_TO_FIND_PLAYLIST";
export const UPDATE_FINAL_FAILED_TO_FIND_PLAYLIST =
	"UPDATE_FINAL_FAILED_TO_FIND_PLAYLIST";
export const CREATE_FAILED_TO_PARSE_PLAYLIST =
	"CREATE_FAILED_TO_PARSE_PLAYLIST";
export const CREATE_FINAL_PLAYLIST_NAMES = "CREATE_FINAL_PLAYLIST_NAMES";
export const UPDATE_FINAL_PLAYLIST_NAME = "UPDATE_FINAL_PLAYLIST_NAME";
export const UPDATE_FINAL_PLAYLIST_URL = "UPDATE_FINAL_PLAYLIST_URL";
export const UPDATE_FINAL_ACCESS_TOKEN = "UPDATE_FINAL_ACCESS_TOKEN";
export const UPDATE_INITIAL_ACCESS_TOKEN = "UPDATE_INITIAL_ACCESS_TOKEN";



// WEBPACK FOOTER //
// ./src/store/actionTypes.js